/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 56692:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(41076);

/***/ }),

/***/ 54203:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var pixel = __webpack_require__(24233);
var gtm = __webpack_require__(70284);
module.exports = {
  pixel: {
    component: pixel
  },
  gtm: {
    component: gtm
  }
};

/***/ }),

/***/ 41076:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _jsx = (__webpack_require__(90029)["default"]);
var _objectSpread = (__webpack_require__(91903)["default"]);
var _reactJsxRuntime = __webpack_require__(20997);
var React = __webpack_require__(16689);
var schema = __webpack_require__(54203);
var Variations = __webpack_require__(6996);
var _require = __webpack_require__(31901),
  LandingContext = _require.LandingContext;
var Tracking = function Tracking(_ref) {
  var index = _ref.index,
    component = _ref.component;
  var _React$useContext = React.useContext(LandingContext),
    components = _React$useContext.landingData.components,
    landingConfig = _React$useContext.landingConfig;
  var json = component || components[index];
  return /*#__PURE__*/_jsx(Variations, {
    json: json,
    schema: schema,
    render: function render(_ref2) {
      var Variation = _ref2.Variation;
      return /*#__PURE__*/_reactJsxRuntime.jsx(Variation, _objectSpread(_objectSpread({}, json.data), landingConfig));
    }
  });
};
Tracking.defaultProps = {
  component: null
};
module.exports = Tracking;

/***/ }),

/***/ 70284:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _jsx = (__webpack_require__(90029)["default"]);
var React = __webpack_require__(16689);
var Script = __webpack_require__(63898);
var GtmIframe = function GtmIframe(_ref) {
  var id = _ref.id;
  return /*#__PURE__*/_jsx("iframe", {
    title: "Google Tag Manager",
    src: "https://www.googletagmanager.com/ns.html?id=".concat(id),
    height: "0",
    width: "0",
    style: {
      display: 'none'
    }
  });
};
var Gtm = function Gtm(_ref2) {
  var _ref2$googleTagManage = _ref2.googleTagManager,
    googleTagManager = _ref2$googleTagManage === void 0 ? null : _ref2$googleTagManage,
    _ref2$lowEnd = _ref2.lowEnd,
    lowEnd = _ref2$lowEnd === void 0 ? false : _ref2$lowEnd;
  if (!googleTagManager) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {}, void 0, !lowEnd ? /*#__PURE__*/_jsx(Script, {
    priority: 200
  }, void 0, "\n          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n          })(window,document,'script','dataLayer','".concat(googleTagManager, "');\n        ")) : /*#__PURE__*/_jsx(GtmIframe, {
    id: googleTagManager
  }));
};
Gtm.defaultProps = {
  googleTagManager: null,
  lowEnd: false
};
module.exports = Gtm;

/***/ }),

/***/ 24233:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _jsx = (__webpack_require__(90029)["default"]);
var React = __webpack_require__(16689);
var Script = __webpack_require__(63898);
var Pixel = function Pixel(_ref) {
  var _ref$pixelId = _ref.pixelId,
    pixelId = _ref$pixelId === void 0 ? '' : _ref$pixelId,
    _ref$pixelEnabled = _ref.pixelEnabled,
    pixelEnabled = _ref$pixelEnabled === void 0 ? false : _ref$pixelEnabled,
    _ref$lowEnd = _ref.lowEnd,
    lowEnd = _ref$lowEnd === void 0 ? false : _ref$lowEnd;
  if (!pixelEnabled || !pixelId) {
    return null;
  }
  if (lowEnd) {
    return /*#__PURE__*/_jsx("img", {
      alt: "fb-pixel",
      height: "1",
      width: "1",
      style: {
        display: 'none'
      },
      src: "https://www.facebook.com/tr?id=".concat(pixelId, "&ev=PageView&noscript=1")
    });
  }
  return /*#__PURE__*/_jsx(Script, {
    priority: 200
  }, void 0, "\n          !function(f,b,e,v,n,t,s)\n            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?\n            n.callMethod.apply(n,arguments):n.queue.push(arguments)};\n            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';\n            n.queue=[];t=b.createElement(e);t.async=!0;\n            t.src=v;s=b.getElementsByTagName(e)[0];\n            s.parentNode.insertBefore(t,s)}(window, document,'script',\n            'https://connect.facebook.net/en_US/fbevents.js');\n            fbq('init', '".concat(pixelId, "');\n            fbq('track', 'PageView');\n          "));
};
Pixel.defaultProps = {
  pixelId: '',
  pixelEnabled: false,
  lowEnd: false
};
module.exports = Pixel;

/***/ }),

/***/ 90029:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/jsx");

/***/ }),

/***/ 91903:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/objectSpread2");

/***/ }),

/***/ 31901:
/***/ ((module) => {

"use strict";
module.exports = require("@splinter/context");

/***/ }),

/***/ 6996:
/***/ ((module) => {

"use strict";
module.exports = require("@splinter/variations");

/***/ }),

/***/ 63898:
/***/ ((module) => {

"use strict";
module.exports = require("frontend-script");

/***/ }),

/***/ 16689:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 20997:
/***/ ((module) => {

"use strict";
module.exports = require("react/jsx-runtime");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module used 'module' so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(56692);
/******/ 	module.exports = __webpack_exports__;
/******/ 	
/******/ })()
;
//# sourceMappingURL=index.production.js.map